import DownloadAllVoucher from '@/views/DownloadAllVoucher/index.vue'

const DownloadAllVoucherRouter = {
  path: '/all_vouchers',
  name: 'DownloadAllVoucher',
  component: DownloadAllVoucher,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default DownloadAllVoucherRouter
